import { PulseProvider } from '@pulse/react';

import { REMOTE_SETTINGS } from 'context/PulseProviderWrapper';
import isServer from 'utils/shared/isServer';

const PulseProviderWrapper = ({ children }) =>
  isServer() ? children : <PulseProvider {...REMOTE_SETTINGS}>{children}</PulseProvider>;
export default PulseProviderWrapper;
